import { render } from "./TempRequestDashboard.vue?vue&type=template&id=83895f72"
import script from "./TempRequestDashboard.vue?vue&type=script&lang=js"
export * from "./TempRequestDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__